"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9071],{

/***/ 89071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ EventListPopup_EventListPopup; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./hooks/common/useOverlay.tsx + 1 modules
var useOverlay = __webpack_require__(91864);
// EXTERNAL MODULE: ./components/common/error/ErrorBoundary.tsx + 8 modules
var ErrorBoundary = __webpack_require__(17550);
// EXTERNAL MODULE: ./components/common/flag/Desktop.tsx
var Desktop = __webpack_require__(76031);
// EXTERNAL MODULE: ./components/common/modal/share/Desktop.tsx + 3 modules
var share_Desktop = __webpack_require__(90451);
// EXTERNAL MODULE: ./components/product/common/popup/common/constant.ts
var constant = __webpack_require__(6243);
// EXTERNAL MODULE: ./components/style/productlist/departurepopup.tsx
var departurepopup = __webpack_require__(89371);
// EXTERNAL MODULE: ./framework/ui/desktop/button/index.ts + 7 modules
var desktop_button = __webpack_require__(9873);
// EXTERNAL MODULE: ./framework/ui/desktop/flag/index.ts
var flag = __webpack_require__(34869);
// EXTERNAL MODULE: ./framework/ui/desktop/layout/index.tsx + 2 modules
var layout = __webpack_require__(31267);
// EXTERNAL MODULE: ./framework/ui/desktop/list/index.ts + 3 modules
var list = __webpack_require__(73255);
// EXTERNAL MODULE: ./framework/ui/desktop/popup/index.ts + 2 modules
var popup = __webpack_require__(7794);
// EXTERNAL MODULE: ./framework/ui/desktop/text/index.ts + 2 modules
var desktop_text = __webpack_require__(81499);
// EXTERNAL MODULE: ./hooks/services/queries/essential/banner/useBannerContents.ts
var useBannerContents = __webpack_require__(72204);
// EXTERNAL MODULE: ./hooks/services/queries/essential/banner/useBannerGoodsDeal.ts
var useBannerGoodsDeal = __webpack_require__(82767);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventByMonth.ts
var useEventByMonth = __webpack_require__(67964);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/goods/useGoodsDetail.ts
var useGoodsDetail = __webpack_require__(3081);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/goods/useGoodsOption.ts
var useGoodsOption = __webpack_require__(29306);
// EXTERNAL MODULE: ./node_modules/@yb/utils/dist/ybutil.cjs.js
var ybutil_cjs = __webpack_require__(20279);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./framework/config/public.ts
var config_public = __webpack_require__(32423);
// EXTERNAL MODULE: ./components/product/pages/localList/common/filterHook.tsx
var filterHook = __webpack_require__(87061);
// EXTERNAL MODULE: ./components/common/eventUtil.ts
var eventUtil = __webpack_require__(99346);
// EXTERNAL MODULE: ./framework/ui/desktop/icon/AirlineIcon.tsx
var AirlineIcon = __webpack_require__(38502);
;// CONCATENATED MODULE: ./components/product/common/popup/desktop/EventListPopup/EventList.tsx









var EventList = function(props) {
    var ref;
    var data = props.data, sort = props.sort, filters = props.filters, setFilters = props.setFilters, currentDate = props.currentDate;
    var eventList = (0,react.useMemo)(function() {
        var filterList = (0,_to_consumable_array/* default */.Z)(data);
        var prop = sort.prop, asc = sort.asc;
        if (currentDate) filterList = filterList.filter(function(v) {
            return v.outStartDt === currentDate;
        });
        /** 정렬 */ filterList = filterList.sort(function(a, b) {
            if (asc) {
                // eslint-disable-next-line no-nested-ternary
                return Number(a[prop]) > Number(b[prop]) ? 1 : Number(a[prop]) < Number(b[prop]) ? -1 : 0;
            } else {
                // eslint-disable-next-line no-nested-ternary
                return Number(b[prop]) > Number(a[prop]) ? 1 : Number(b[prop]) < Number(a[prop]) ? -1 : 0;
            }
        });
        return filterList;
    }, [
        data,
        sort,
        currentDate
    ]);
    // 예약 마감된 상품도 함께 보기
    var handleFilterReserve = function() {
        var copyArray = filters.filter(function(v) {
            return v.key !== "isEvReserve";
        });
        setFilters(copyArray);
    };
    // 예약가능 여부
    var isReserve = ((ref = filters.find(function(v) {
        return v.key === "isEvReserve";
    })) === null || ref === void 0 ? void 0 : ref.value) === "true";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* PromotionList */.Dq, {
        children: [
            eventList.length > 0 && eventList.map(function(item, index) {
                var trTp = item.trTp, trCompanyNm = item.trCompanyNm, outDeprtTm = item.outDeprtTm, inArrvTm = item.inArrvTm, evReserveStatus = item.evReserveStatus, goodsTp = item.goodsTp, seatClassCd = item.seatClassCd, seatClassNm = item.seatClassNm;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: item.weblinkurl || "#",
                        target: "_blank",
                        rel: "noreferrer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* PromotionDate */.q, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: "".concat((0,eventUtil/* departureStart */.jn)({
                                                    evStartDt: item.outStartDt,
                                                    outDeprtTm: outDeprtTm
                                                }), " - ").concat((0,eventUtil/* returnArrival */.jp)({
                                                    evArriveDt: item.inArriveDt,
                                                    inArrvTm: inArrvTm
                                                }))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: item.dayStayInfo.replace(/^(\d)박(\d)일$/, "$1박 $2일")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                                        gap: "6",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop/* FlagEmpasisCd */.k0, {
                                                emphasisCd: item.emphasisCd
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop/* FlagEvProgDivi */.X, {
                                                evProgDivi: item.evProgDivi,
                                                evProgDiviNm: item.evProgDiviNm
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* PromotionTitle */.GU, {
                                children: item.evNm
                            }),
                            item.accomNm && /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* PromotionOption */.Mo, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "옵션"
                                    }),
                                    item.accomNm
                                ]
                            }),
                            item.couponYn === "Y" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* CouponBox */.ql, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                        children: "쿠폰"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* CouponIcon */.zc, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            children: item.couponOptTy === "M" ? ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(item.couponDiscAmt) : "".concat(item.couponDiscRate, "%")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* PromotionPrice */.S2, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* Flex */.kC, {
                                        grow: 1,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AirlineIcon/* default */.Z, {
                                            img: (0,eventUtil/* getTrafficIconUrl */.wz)(item),
                                            title: trTp ? "".concat(trCompanyNm, " ").concat(seatClassCd && seatClassCd !== "EC" ? "(".concat(seatClassNm, ")") : "") : "교통불포함"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            [
                                                "F",
                                                "H"
                                            ].indexOf(item.goodsTp) === -1 && item.evProgDivi !== "05" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* SeatsAvailable */.xF, {
                                                children: [
                                                    "(잔여 ",
                                                    item.avlilBlockQty,
                                                    "석)"
                                                ]
                                            }),
                                            evReserveStatus === "end" && /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* Status */.qb, {
                                                state: "deadline",
                                                children: "예약마감"
                                            }),
                                            evReserveStatus === "wait" && /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* Status */.qb, {
                                                state: "waiting",
                                                children: "예약대기"
                                            }),
                                            evReserveStatus === "can" && /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* Status */.qb, {
                                                state: "possible",
                                                children: [
                                                    "F",
                                                    "H"
                                                ].indexOf(goodsTp) > -1 ? "예약접수가능" : "예약가능"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* Price */.tA, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                        children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(item.sumPrice)
                                                    }),
                                                    "원~"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }, index);
            }),
            !eventList || eventList.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* EmptyBox */.cs, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: isReserve ? "해당 조건으로 예약가능한 상품이 없습니다." : "해당 조건의 상품이 없습니다."
                        }),
                        isReserve && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            onClick: handleFilterReserve,
                            children: "예약 마감된 상품도 함께 보기"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var EventListPopup_EventList = (EventList);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(93391);
// EXTERNAL MODULE: ./framework/ui/desktop/select/index.ts
var desktop_select = __webpack_require__(64249);
// EXTERNAL MODULE: ./components/hoc/withCalendar.tsx
var withCalendar = __webpack_require__(25893);
// EXTERNAL MODULE: ./hooks/services/queries/essential/contents/useContentsHoliday.ts
var useContentsHoliday = __webpack_require__(6843);
;// CONCATENATED MODULE: ./components/product/common/popup/desktop/EventListPopup/EventListCalendar.tsx


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 400px;\n	background-color: #fff;\n\n	table {\n		th {\n			height: 44px;\n			background-color: #fff;\n			text-align: center;\n			border-top: none;\n		}\n		td {\n			height: 77px;\n			padding: 0;\n			border: 1px solid var(--line-color);\n			&:not(:last-child) {\n				border-right-color: #eee;\n			}\n		}\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	border-top: 1px solid var(--line-color);\n	border-right: 1px solid var(--line-color);\n	border-left: 1px solid var(--line-color);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	display: flex;\n	width: 177px;\n	height: 70px;\n	margin: 0 auto;\n	justify-content: center;\n\n	em {\n		font-size: 22px;\n		font-weight: bold;\n		color: var(--emp-color);\n		line-height: 1;\n	}\n	label {\n		font-size: var(--medium-size);\n		font-weight: normal;\n	}\n	ul {\n		top: 50px;\n		left: 50%;\n		width: 245px;\n		max-height: 155px;\n		transform: translateX(-50%);\n		> li {\n			justify-content: center;\n			padding: 0;\n		}\n	}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	top: 32px;\n	width: 9px;\n	height: 9px;\n	border-left: 1px solid var(--emp-color);\n	border-bottom: 1px solid var(--emp-color);\n	background-color: transparent;\n\n	&:disabled {\n		border-color: var(--bl-color);\n	}\n\n	",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	table-layout: fixed;\n\n	th {\n		&:first-child {\n			border-left: 1px solid var(--line-color);\n		}\n\n		&:last-child {\n			border-right: 1px solid var(--line-color);\n		}\n	}\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	height: 35px;\n	padding: 10px;\n	box-sizing: border-box;\n	border-top: 1px solid var(--line-color);\n	color: var(--emp-color);\n	text-align: center;\n	&:first-child {\n		color: #ff5c46;\n	}\n	&:last-child {\n		color: #4567ad;\n	}\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	box-sizing: border-box;\n	height: 35px;\n	color: #aaa;\n	vertical-align: top;\n	text-align: left;\n	cursor: initial;\n\n	> span {\n		border: 1px solid transparent;\n		outline: 1px solid ",
        ";\n		font-size: var(--basic-size);\n		box-sizing: border-box;\n	}\n\n	&:first-child {\n		> span {\n			color: var(--red-color);\n		}\n	}\n	&:last-child {\n		> span {\n			color: var(--blue-color);\n		}\n	}\n	",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	display: flex;\n	padding-top: 4px;\n	width: 100%;\n	height: 100%;\n	color: ",
        ";\n	align-items: start;\n	justify-content: center;\n	line-height: 1;\n	z-index: 2;\n\n	span {\n		display: flex;\n		width: 26px;\n		padding: 5px 0 7px;\n		align-items: center;\n		justify-content: center;\n		z-index: 2;\n	}\n	",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n			color: #ff3e24;\n		"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: absolute;\n	display: flex;\n	bottom: 0;\n	width: 100%;\n	height: 40px;\n	font-size: 13px;\n	color: var(--default-color);\n	align-items: center;\n	justify-content: center;\n\n	",
        "\n	",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n	letter-spacing: 0;\n	label {\n		font-size: 22px;\n		font-family: "pr-font-medium";\n	}\n\n	&:before {\n		right: -15px;\n		top: 35px;\n	}\n'
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}









var CalendarBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-13161407-0"
})(_templateObject());
var CalendarMonthWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-13161407-1"
})(_templateObject1());
var CalendarMonth = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-13161407-2"
})(_templateObject2());
var MonthButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-13161407-3"
})(_templateObject3(), function(props) {
    return props.types === "prev" ? "\n                left: 0px;\n                transform: rotate(45deg);\n            " : "\n                right: 0px;\n                transform: rotate(-135deg);\n            ";
});
var TableCalendar = styled_components_browser_esm/* default.table.withConfig */.ZP.table.withConfig({
    componentId: "sc-13161407-4"
})(_templateObject4());
var Month = styled_components_browser_esm/* default.th.withConfig */.ZP.th.withConfig({
    componentId: "sc-13161407-5"
})(_templateObject5());
var ProductDays = styled_components_browser_esm/* default.td.withConfig */.ZP.td.withConfig({
    componentId: "sc-13161407-6"
})(_templateObject6(), function(props) {
    return props.CheckedDay ? "var(--emp-color)" : "transparent";
}, function(props) {
    return props.isActive && "\n        color: var(--emp-color);\n        cursor: pointer;\n\n        &:hover {\n            > span {\n                outline: 1px solid var(--emp-color);\n            }\n        }\n    ";
});
var Day = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-13161407-7"
})(_templateObject7(), function(props) {
    return props.holiday ? "var(--red-color)" : "";
}, function(props) {
    return props.today && "\n			span {\n				border-radius: 50%;\n				background-color: var(--emp-color);\n				color: #fff;\n			}\n		";
});
var ResStatus = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-13161407-8"
})(_templateObject9(), function(props) {
    if (props.state === "possible") {
        return "\n			background-color: var(--yellow-color);\n		  ";
    }
    if (props.state === "waiting") {
        return "\n			background-color: #bfd1f5;\n		  ";
    }
    if (props.state === "deadline") {
        return "\n			background-color: var(--line-color);\n		  ";
    }
}, function(props) {
    return props.lowestPrice && (0,styled_components_browser_esm/* css */.iv)(_templateObject8());
});
var CalendarSelectBox = (0,styled_components_browser_esm/* default */.ZP)(desktop_select/* SelectBox */.jL).withConfig({
    componentId: "sc-13161407-9"
})(_templateObject10());
var formatPrice = function(prop) {
    if (prop < 10000) {
        return "".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(prop), "원~");
    }
    var million = Math.floor(prop / 10000);
    return "".concat(million, "만~");
};
var EventListCalendar = (0,withCalendar/* default */.Z)(function(props, ref) {
    var date = props.date, isNext = props.isNext, isPrevious = props.isPrevious, rangeMonth = props.rangeMonth, // dayList,
    month = props.month, // min,
    // max,
    data = props.data, // clearDate,
    dateChange = props.dateChange, monthChange = props.monthChange, nextMonth = props.nextMonth, prevMonth = props.prevMonth;
    var id = (0,react.useId)();
    var ref1 = (0,react.useState)(false), showMonth = ref1[0], setShowMonth = ref1[1];
    (0,react.useEffect)(function() {
        var event = function(e) {
            if (document.body.contains(e.target)) {
                !e.target.closest("#selectWrap-".concat(CSS.escape(id))) && setShowMonth(false);
                e.target.closest("#options-".concat(CSS.escape(id))) && setShowMonth(false);
            }
        };
        setTimeout(function() {
            return window.addEventListener("click", event);
        });
        return function() {
            window.removeEventListener("click", event);
        };
    }, []);
    var eventList = data === null || data === void 0 ? void 0 : data.eventList;
    var minPrice = data === null || data === void 0 ? void 0 : data.minPrice;
    var holidayFetch = (0,useContentsHoliday/* default */.ZP)(dayjs_min_default()(month).format("YYYY"), {
        staleTime: 1000 * 60 * 5
    });
    var today = dayjs_min_default()();
    var groupByEvStartDt = (0,react.useMemo)(function() {
        var result = {};
        if (!eventList) return result;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = eventList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                var outStartDt = item.outStartDt;
                if (!result[outStartDt]) {
                    result[outStartDt] = [];
                }
                result[outStartDt].push(item);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return result;
    }, [
        eventList,
        month
    ]);
    var makeEventDayList = (0,react.useCallback)(function(referenceDate) {
        var dayCount = referenceDate.date(1).daysInMonth();
        /** 1~7 월~일 */ var startWeekDay = referenceDate.day();
        var endWeekDay = referenceDate.date(dayCount).day();
        var firstWeekEmptyArray = Array(startWeekDay).fill(null);
        var lastWeekEmptyArray = Array(6 - endWeekDay).fill(null);
        var dayArray = Array(dayCount).fill(0).map(function(o, index) {
            var _Math;
            var ref, ref1, ref2;
            var result = {};
            var day = referenceDate.add(index, "day");
            var dayFormat = day.format("YYYYMMDD");
            /* 공휴일 */ var holiday = !!((ref = holidayFetch.data) === null || ref === void 0 ? void 0 : ref.body.find(function(v) {
                return v.calDt === dayFormat;
            }));
            /* 최저가 */ var priceArray = ((ref1 = groupByEvStartDt[dayFormat]) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                return item.sumPrice;
            })) || [];
            var price = priceArray.length > 0 ? (_Math = Math).min.apply(_Math, (0,_to_consumable_array/* default */.Z)(priceArray)) : 0;
            /* can: 예약가능, wait: 예약대기, end: 예약마감 */ var calStatusArray = ((ref2 = groupByEvStartDt[dayFormat]) === null || ref2 === void 0 ? void 0 : ref2.map(function(item) {
                return item.evReserveStatus;
            })) || [];
            var resStatus = "";
            if (calStatusArray.includes("can")) {
                resStatus = "possible";
            } else if (calStatusArray.includes("wait")) {
                resStatus = "waiting";
            } else if (calStatusArray.includes("end")) {
                resStatus = "deadline";
            }
            result = {
                day: day,
                resStatus: resStatus,
                price: price,
                holiday: holiday
            };
            return result;
        });
        return (0,_to_consumable_array/* default */.Z)(firstWeekEmptyArray).concat((0,_to_consumable_array/* default */.Z)(dayArray), (0,_to_consumable_array/* default */.Z)(lastWeekEmptyArray));
    }, [
        groupByEvStartDt
    ]);
    /** event day 주 단위로 삽입 */ var eventDayList = (0,react.useMemo)(function() {
        var days = makeEventDayList(month.date(1));
        return Array.from({
            length: days.length / 7
        }).map(function() {
            return days.splice(0, 7);
        });
    }, [
        makeEventDayList
    ]);
    /** 첫 랜더링 디폴트 세팅 */ (0,react.useEffect)(function() {
        if (month) dateChange(null);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* ScheduleTitle */.Hr, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        children: "출발일 선택"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* ReservationBox */.me, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* ReservationText */._9, {
                                state: "possible",
                                children: "예약가능"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* ReservationText */._9, {
                                state: "waiting",
                                children: "예약대기"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* ReservationText */._9, {
                                state: "deadline",
                                children: "예약마감"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CalendarBox, {
                id: id,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarMonthWrap, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CalendarMonth, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(desktop_select/* SelectWrap */.vA, {
                                    width: 83,
                                    id: "selectWrap-".concat(id),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarSelectBox, {
                                            types: "calendar",
                                            onClick: function() {
                                                return setShowMonth(!showMonth);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_select/* SelectLabel */.n5, {
                                                isActive: true,
                                                children: month.format("YYYY.MM")
                                            })
                                        }),
                                        showMonth && /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_select/* SelectOptions */.PN, {
                                            id: "options-".concat(id),
                                            children: rangeMonth === null || rangeMonth === void 0 ? void 0 : rangeMonth.map(function(day, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    value: day.format("YYYYMMDD"),
                                                    onClick: function(e) {
                                                        monthChange(String(e.currentTarget.value));
                                                        dateChange(null); // 선택일 초기화
                                                    },
                                                    children: day.format("YYYY.MM")
                                                }, index);
                                            })
                                        })
                                    ]
                                }),
                                isPrevious && /*#__PURE__*/ (0,jsx_runtime.jsx)(MonthButton, {
                                    types: "prev",
                                    onClick: function() {
                                        prevMonth();
                                        dateChange(null);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "이전달"
                                    })
                                }),
                                isNext && /*#__PURE__*/ (0,jsx_runtime.jsx)(MonthButton, {
                                    types: "next",
                                    onClick: function() {
                                        nextMonth();
                                        dateChange(null);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "다음달"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCalendar, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                            children: "일"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                            children: "월"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                            children: "화"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                            children: "수"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                            children: "목"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                            children: "금"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Month, {
                                            children: "토"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                                children: eventDayList === null || eventDayList === void 0 ? void 0 : eventDayList.map(function(week, index) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("tr", {
                                        children: week.map(function(item, weekIdx) {
                                            var day = item === null || item === void 0 ? void 0 : item.day;
                                            var price = (item === null || item === void 0 ? void 0 : item.price) || 0;
                                            var isActive = !(day < today.add(-1, "day")) && price > 0 || !!(item === null || item === void 0 ? void 0 : item.resStatus);
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductDays, {
                                                isActive: isActive,
                                                onClick: function() {
                                                    if (isActive) {
                                                        var isSameDay = date === null || date === void 0 ? void 0 : date.isSame(day);
                                                        dateChange(!isSameDay ? day : null);
                                                    }
                                                },
                                                CheckedDay: date && date.isSame(day),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Day, {
                                                        today: day && today.isSame(day, "day"),
                                                        holiday: item === null || item === void 0 ? void 0 : item.holiday,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: day && day.format("DD")
                                                        })
                                                    }),
                                                    price > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ResStatus, {
                                                        state: (item === null || item === void 0 ? void 0 : item.resStatus) || "",
                                                        lowestPrice: price === Number(minPrice),
                                                        children: formatPrice(price)
                                                    })
                                                ]
                                            }, weekIdx);
                                        })
                                    }, index);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
/* harmony default export */ var EventListPopup_EventListCalendar = (EventListCalendar);

// EXTERNAL MODULE: ./components/common/modal/alert/Desktop.tsx
var alert_Desktop = __webpack_require__(64024);
// EXTERNAL MODULE: ./framework/ui/desktop/filter/index.tsx
var filter = __webpack_require__(59758);
// EXTERNAL MODULE: ./framework/ui/desktop/input/index.ts + 7 modules
var input = __webpack_require__(58127);
// EXTERNAL MODULE: ./framework/ui/desktop/table/index.ts + 1 modules
var table = __webpack_require__(5540);
;// CONCATENATED MODULE: ./components/product/common/popup/desktop/EventListPopup/EventListFIlters.tsx













var EventListFilters = function(prop) {
    var filters = prop.filters, setFilters = prop.setFilters, option = prop.option, goods = prop.goods;
    var goodsCd = goods.goodsCd, webDisplayCls = goods.webDisplayCls;
    var goodsState = [
        {
            key: "isEvReserve",
            text: "예약가능",
            value: "true"
        },
        {
            key: "isEvConfirm",
            text: "출발확정",
            value: "true"
        }, 
    ];
    var ref = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), open = ref[0];
    var handleFilters = function(e, key) {
        var _target = e.target, value = _target.value, checked = _target.checked;
        var text = e.target.parentNode.innerText;
        if (checked) {
            var copyArray = filters;
            var copyArrayExists = copyArray.some(function(item) {
                return item.value === value && item.key === key;
            }); /* 중복제거 */ 
            if (copyArrayExists) return;
            setFilters((0,_to_consumable_array/* default */.Z)(filters).concat([
                {
                    key: key,
                    value: value,
                    text: text
                }
            ]));
        } else {
            if (key === "trCompanySnm" && filters.filter(function(v) {
                return v.key === "trCompanySnm";
            }).length === 1) {
                open(function(props) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_Desktop/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        text: "교통편은 최소 1개 이상 선택하셔야 합니다."
                    }));
                });
                return false;
            }
            if (key === "accomSeq" && filters.filter(function(v) {
                return v.key === "accomSeq";
            }).length === 1) {
                open(function(props) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_Desktop/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                        text: "옵션은 최소 1개 이상 선택하셔야 합니다."
                    }));
                });
                return false;
            }
            var copyArray1 = filters;
            var setArray = copyArray1.filter(function(item) {
                return !(item.value === value && item.key === key);
            }); /* 동일한 value 제거 */ 
            setFilters(setArray);
        }
    };
    var handleFilterRemove = function(key, value) {
        var copyArray = filters;
        var setArray = copyArray.filter(function(item) {
            if (key === "price") {
                return !(item.key === "minPrice" || item.key === "maxPrice");
            } else {
                return !(item.value === value && item.key === key);
            }
        }); /* 동일한 value 제거 */ 
        setFilters(setArray);
    };
    var handleRemoveAll = function() {
        var setArray = filters.filter(function(v) {
            return constant/* D_DELETE_EXCLUDE_KEYS.includes */.CR.includes(v.key);
        });
        setFilters(setArray);
    };
    // 옵션 더보기 버튼
    var infoWrapRef = (0,react.useRef)(null);
    var infoContentRef = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(false), showText = ref1[0], setShowText = ref1[1];
    var ref2 = (0,react.useState)(false), shouldShowButton = ref2[0], setShouldShowButton = ref2[1];
    var toggleText = function() {
        setShowText(!showText);
        setShouldShowButton(false);
    };
    (0,react.useEffect)(function() {
        var ref, ref1;
        var textHeight = (ref = infoContentRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight;
        var textWrapHeight = (ref1 = infoWrapRef.current) === null || ref1 === void 0 ? void 0 : ref1.clientHeight;
        if (textHeight > textWrapHeight) {
            setShouldShowButton(true);
        } else {
            setShouldShowButton(false);
        }
    }, [
        option
    ]);
    // 선택된 필터
    var showFilter = (0,react.useMemo)(function() {
        var arr = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (key === "minPrice") {
                    var minPrice = filters.find(function(v) {
                        return v.key === "minPrice";
                    });
                    if (minPrice) arr = (0,_to_consumable_array/* default */.Z)(arr).concat([
                        {
                            key: "price",
                            text: minPrice.text
                        }
                    ]);
                } else if (key === "maxPrice") {
                    var maxPrice = filters.find(function(v) {
                        return v.key === "maxPrice";
                    });
                    var priceObject = arr.find(function(v) {
                        return v.key === "price";
                    });
                    if (priceObject && maxPrice) priceObject.text += " ~ ".concat(maxPrice.text);
                } else {
                    arr = (0,_to_consumable_array/* default */.Z)(arr).concat((0,_to_consumable_array/* default */.Z)(filters.filter(function(v) {
                        return v.key === key;
                    })));
                }
            };
            for(var _iterator = constant/* D_SHOW_KEYS */.D9[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return arr;
    }, [
        filters
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showFilter.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* FilterTagContainer */.m2, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* FilterTitle */.Ux, {
                        children: "필터"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* FilterTagBox */.lD, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* ResetButton */.JK, {
                                    type: "button",
                                    onClick: handleRemoveAll,
                                    children: "전체 삭제"
                                })
                            }),
                            showFilter.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* FilterTag */.dB, {
                                        children: [
                                            item.text,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* FilterTagDeleteButton */.i4, {
                                                onClick: function() {
                                                    return handleFilterRemove(item.key, item.value);
                                                },
                                                children: "닫기"
                                            })
                                        ]
                                    })
                                }, "".concat(goodsCd).concat(index));
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* FilterCheckWrap */.FB, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(table/* TableContainer */.x, {
                    lineTop: true,
                    types: "basic",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                            children: "상품가 안내"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                    style: {
                                        width: "120px"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                    style: {
                                        width: "auto"
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            children: "상품 상태"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* CheckBox */.Jg, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(filter/* GridList */.e_, {
                                                    columns: "repeat(4, 1fr)",
                                                    children: goodsState.map(function(item, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Checkbox */.XZ, {
                                                                    id: "state".concat(goodsCd).concat(index),
                                                                    value: "".concat(item.value),
                                                                    checked: filters.some(function(v) {
                                                                        return v.key === item.key;
                                                                    }) || false,
                                                                    onChange: function(e) {
                                                                        return handleFilters(e, item.key);
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "state".concat(goodsCd).concat(index),
                                                                    children: item.text
                                                                })
                                                            ]
                                                        }, index);
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }),
                                (option === null || option === void 0 ? void 0 : option.trafficList) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            children: "교통편"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* CheckBox */.Jg, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(filter/* GridList */.e_, {
                                                    columns: "repeat(4, 1fr)",
                                                    children: option.trafficList.map(function(item, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Checkbox */.XZ, {
                                                                    id: "airline".concat(goodsCd).concat(index),
                                                                    value: "".concat(item.trCompanySnm),
                                                                    checked: filters.some(function(v) {
                                                                        return v.value === item.trCompanySnm;
                                                                    }) || false,
                                                                    onChange: function(e) {
                                                                        return handleFilters(e, "trCompanySnm");
                                                                    }
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                    htmlFor: "airline".concat(goodsCd).concat(index),
                                                                    children: item.trCompanySnm === "ETC" ? "교통불포함" : item.trCompanyNm
                                                                })
                                                            ]
                                                        }, index);
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }),
                                webDisplayCls === "B" && (option === null || option === void 0 ? void 0 : option.accommodationList) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            children: "옵션"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* CheckBox */.Jg, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* OptionCheckList */.qe, {
                                                        show: showText,
                                                        ref: infoWrapRef,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(filter/* GridList */.e_, {
                                                            columns: "1fr",
                                                            ref: infoContentRef,
                                                            children: option.accommodationList.map(function(item, index) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* Checkbox */.XZ, {
                                                                            id: "option".concat(goodsCd).concat(index),
                                                                            value: "".concat(item.accomSeq),
                                                                            checked: filters.some(function(v) {
                                                                                return v.value === String(item.accomSeq);
                                                                            }) || false,
                                                                            onChange: function(e) {
                                                                                return handleFilters(e, "accomSeq");
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                            htmlFor: "option".concat(goodsCd).concat(index),
                                                                            children: item.accomNm
                                                                        })
                                                                    ]
                                                                }, index);
                                                            })
                                                        })
                                                    }),
                                                    shouldShowButton && option.accommodationList.length > 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* BenefitButton */.Xk, {
                                                        type: "button",
                                                        onClick: toggleText,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "더보기"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var EventListFIlters = (EventListFilters);

// EXTERNAL MODULE: ./components/common/commonUtil.ts
var commonUtil = __webpack_require__(2576);
// EXTERNAL MODULE: ./hooks/common/useCountdown.tsx
var useCountdown = __webpack_require__(71392);
// EXTERNAL MODULE: ./public/P/images/ico/ico_nodata.png
var ico_nodata = __webpack_require__(39044);
var ico_nodata_default = /*#__PURE__*/__webpack_require__.n(ico_nodata);
// EXTERNAL MODULE: ./node_modules/dayjs/plugin/isBetween.js
var isBetween = __webpack_require__(66607);
var isBetween_default = /*#__PURE__*/__webpack_require__.n(isBetween);
// EXTERNAL MODULE: ./hooks/common/useTagging.ts + 5 modules
var useTagging = __webpack_require__(40070);
;// CONCATENATED MODULE: ./components/product/common/popup/desktop/EventListPopup/EventListBanner.tsx










var daykor = [
    "일",
    "월",
    "화",
    "수",
    "목",
    "금",
    "토"
];
var BannerContents = function(param) {
    var contents = param.contents;
    // 이미지 없을 경우 구름 이미지 표시
    var imageOnError = function(e) {
        e.currentTarget.src = (ico_nodata_default());
        e.currentTarget.className = "img-error";
    };
    var taggingClick = (0,useTagging/* useTaggingClick */.b)("pkg_select_promo_calender", {
        selectDiv: "calenderMidBanner"
    }).taggingClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* EventBanner */.cK, {
        children: contents && contents.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL).concat(item.link),
                target: (0,commonUtil/* getTarget */.U9)(item.target),
                onClick: function() {
                    return taggingClick(item);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "".concat(config_public/* default.ENV_CIMG_CDN_URL */.Z.ENV_CIMG_CDN_URL).concat(item.imgPath),
                    alt: item.alt,
                    onError: imageOnError
                })
            }, index);
        })
    });
};
var BannerYellowLive = function(param) {
    var live = param.live;
    dayjs_min_default().extend((isBetween_default())); // isBetween 사용
    var dspYn = live.dspYn, liveDt = live.liveDt, liveTime = live.liveTime;
    // 방송 노출 조건 Y가 아닌 경우 - 노출 X
    if (dspYn !== "Y") return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var liveStartDate = dayjs_min_default()(liveDt);
    var liveEndDate = liveStartDate.add(Number(liveTime), "minute");
    var today = dayjs_min_default()();
    var LiveText = function() {
        if (today.isBefore(liveStartDate)) {
            var countdown = (0,useCountdown/* default */.Z)(liveStartDate);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* LiveDate */.Uq, {
                        children: "COMING SOON"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* LiveState */.I7, {
                        children: countdown
                    })
                ]
            });
        } else if (today.isBetween(liveStartDate, liveEndDate)) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* LiveDate */.Uq, {
                        children: "ON AIR"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* LiveState */.I7, {
                        children: "실시간 방송 중"
                    })
                ]
            });
        } else {
            var formattedDate = "".concat(liveStartDate.format("MM/DD"), "(").concat(daykor[liveStartDate.day()], ") ").concat(liveStartDate.format("HH:mm"));
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* LiveDate */.Uq, {
                        children: formattedDate
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* LiveState */.I7, {
                        children: "방영 완료"
                    })
                ]
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* BannerYellowLive */.$g, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            href: "".concat(config_public/* default.ENV_PORTAL_URL */.Z.ENV_PORTAL_URL, "/promotion/yellowLive"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* LiveText */.sS, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* LiveTit */.TH, {
                            children: "최대 혜택으로 떠나는 생생한 여행"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LiveText, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* LiveLink */.Ge, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "바로가기"
                    })
                })
            ]
        })
    });
};
var BannerYellowPangDeal = function(param) {
    var deal = param.deal;
    var PangdealText = function() {
        var targetDate = dayjs_min_default()(deal.dealEdTm).add(1, "minute");
        var countdown = (0,useCountdown/* default */.Z)(targetDate);
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* PangdealText */.Kr, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* PangdealProduct */.pb, {
                            children: deal.dealType === "T" ? "타임특가" : "선착순특가"
                        }),
                        "\xa0",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* PangdealDate */.Q0, {
                            children: deal.dealType === "T" ? countdown !== null && countdown !== void 0 ? countdown : "종료" : "상품 ".concat(deal.dealRervCnt || 0, "개")
                        }),
                        countdown !== null && " 남음"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "".concat(deal.dealRervCnt > 0 || countdown !== null ? "".concat(ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(deal.price - deal.dealGoodsPrice), "원 즉시할인가격") : "")
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* BannerYellowpangdeal */.yn, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            target: "_self",
            href: "".concat(config_public/* default.ENV_PACKAGE_URL */.Z.ENV_PACKAGE_URL, "/promotion/yellowPangDeal.yb"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* PangdealPrice */.G_, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PangdealText, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* PangdealLink */.rV, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "전체보기"
                    })
                })
            ]
        })
    });
};


// EXTERNAL MODULE: ./hooks/services/queries/bff/global/useGlobalGoodsLive.ts
var useGlobalGoodsLive = __webpack_require__(28906);
;// CONCATENATED MODULE: ./components/product/common/popup/desktop/EventListPopup/EventListPopup.tsx


































var EventInfo = function(goods) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var router = (0,next_router.useRouter)();
    var dspSid = "".concat((ref = router.query) === null || ref === void 0 ? void 0 : (ref1 = ref.dspSid) === null || ref1 === void 0 ? void 0 : ref1.slice(0, -3), "000");
    var menu = (ref2 = router.query) === null || ref2 === void 0 ? void 0 : ref2.menu;
    var bannerContentsFetch = (0,useBannerContents/* default */.ZP)("GOST"); // WEB_CONT_DIVI_CD 출발일보기
    var bannerContents = (ref3 = bannerContentsFetch.data) === null || ref3 === void 0 ? void 0 : ref3.body;
    var bannerDealFetch = (0,useBannerGoodsDeal/* default */.ZP)(goods.goodsCd);
    var bannerDeal = (ref4 = bannerDealFetch.data) === null || ref4 === void 0 ? void 0 : ref4.body;
    var bannerLiveFetch = (0,useGlobalGoodsLive/* default */.Z)(goods.goodsCd);
    var bannerLive = (ref5 = bannerLiveFetch.data) === null || ref5 === void 0 ? void 0 : ref5.body;
    // 공유하기
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useOverlay/* default */.Z)(), 1), open = ref6[0];
    var handleShare = function() {
        open(function(prop) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(share_Desktop/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prop), {
                baseUrl: "".concat(config_public/* default.ENV_PRODUCT_URL */.Z.ENV_PRODUCT_URL, "/product/localList"),
                parameter: "menu=".concat(menu, "&dspSid=").concat(dspSid, "&goodsCd=").concat(goods.goodsCd)
            }));
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* ContentTop */.an, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* SummaryInfo */.T7, {
                justify: "space-between",
                align: "start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* TagSquareWrap */.N$, {
                        gap: "5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop/* FlagGoodsCd */.G, {
                                goodsCd: goods.goodsCd
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop/* FlagGoodsTp */.B2, {
                                goodsTp: goods.goodsTp
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop/* FlagGoodsBrandCd */.hA, {
                                goodsBrandCd: goods.goodsBrandCd
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Desktop/* FlagGoodsTmember */.$4, {
                                goodsTmember: goods.goodsTmember
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(list/* StackList */.fe, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* StackListItem */.jS, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(flag/* StarIcon */.r7, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* Grade */.GR, {
                                            children: goods.rvwAvgScore > 0 ? goods.rvwAvgScore : "-"
                                        }),
                                        "/ 5"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* StackListItem */.jS, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_button/* IconButton */.hU, {
                                    icon: "share",
                                    isActive: false,
                                    onClick: handleShare,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "공유하기"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* TopTitle */.ne, {
                children: goods.goodsNm
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* TopPriceBox */.Yo, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                        gap: "2",
                        align: "center",
                        children: [
                            "최저가",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(desktop_text/* RedText */.xK, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                        children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(goods.minPrice)
                                    }),
                                    " 원"
                                ]
                            }),
                            "(",
                            dayjs_min_default()(goods.minPriceDate).format("YYYY.MM.DD"),
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* Flex */.kC, {
                        gap: "2",
                        align: "center",
                        children: [
                            "최고가",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(desktop_text/* RedText */.xK, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                        children: ybutil_cjs/* format.koKRFormatNumber */.WU.koKRFormatNumber(goods.maxPrice)
                                    }),
                                    " 원"
                                ]
                            }),
                            "(",
                            dayjs_min_default()(goods.maxPriceDate).format("YYYY.MM.DD"),
                            ")"
                        ]
                    })
                ]
            }),
            bannerContents && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerContents, {
                contents: bannerContents
            }),
            bannerDeal && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerYellowPangDeal, {
                deal: bannerDeal
            }),
            bannerLive && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerYellowLive, {
                live: bannerLive
            })
        ]
    });
};
var EventSort = function(props) {
    var sort = props.sort, handleSort = props.handleSort;
    var Rating = [
        {
            text: "출발일순",
            prop: "outStartDt",
            asc: true
        },
        {
            text: "낮은가격순",
            prop: "sumPrice",
            asc: true
        },
        {
            text: "높은가격순",
            prop: "sumPrice",
            asc: false
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* ScheduleTitle */.Hr, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                children: "일정 선택"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(list/* StackList */.fe, {
                cursor: "pointer",
                children: Rating.map(function(item, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(list/* StackListItem */.jS, {
                        "data-prop": item.prop,
                        "data-asc": item.asc,
                        "data-text": item.text,
                        isActive: (sort === null || sort === void 0 ? void 0 : sort.text) === item.text,
                        onClick: handleSort,
                        children: item.text
                    }, index);
                })
            })
        ]
    });
};
var EventContentsComponent = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var getFilter = (0,filterHook/* default */.Z)().getFilter;
    var ref6 = (0,react.useState)([]), filters = ref6[0], setFilters = ref6[1];
    var router = (0,next_router.useRouter)();
    var goods = props.goods, availEvent = props.availEvent, onClose = props.onClose;
    var goodsCd = goods.goodsCd, webDisplayCls = goods.webDisplayCls, minPrice = goods.minPrice;
    var dspSid = "".concat((ref = router.query) === null || ref === void 0 ? void 0 : (ref1 = ref.dspSid) === null || ref1 === void 0 ? void 0 : ref1.slice(0, -2), "00");
    var optionFetch = (0,useGoodsOption/* default */.ZP)(goodsCd, {
        staleTime: 1000 * 60
    });
    var option = (ref2 = optionFetch.data) === null || ref2 === void 0 ? void 0 : ref2.body;
    var calendarRef = (0,react.useRef)(null);
    /** 행사리스트 필터링에 사용 (YYYYMMDD) */ var ref7 = (0,react.useState)(null), currentDate = ref7[0], setCurrentDate = ref7[1];
    /** 달력 세팅에 사용 (YYYYMM) */ var ref8 = (0,react.useState)(null), currentMonth = ref8[0], setCurrentMonth = ref8[1];
    /** 최소 날짜, 최대 날짜, 이벤트 날짜 세팅 */ var ref9 = (0,react.useMemo)(function() {
        if (!availEvent) return [
            null,
            null
        ];
        var _eventMonthList = availEvent.eventMonthList, minOutStartDt = _eventMonthList.minOutStartDt, maxOutStartDt = _eventMonthList.maxOutStartDt;
        setCurrentMonth(dayjs_min_default()(availEvent.evStartDt).date(1).format("YYYYMM"));
        return [
            minOutStartDt,
            maxOutStartDt
        ];
    }, [
        availEvent
    ]), minDate = ref9[0], maxDate = ref9[1];
    /** 필터링 된 날짜 세팅 */ (0,react.useEffect)(function() {
        if (!filters.length) return;
        var dateFilter = filters.find(function(v) {
            return v.key === "outStartDt";
        });
        var monthFilter = filters.find(function(v) {
            return v.key === "outStartMonth";
        });
        var newDate = dateFilter ? dateFilter.value : null;
        var newMonth = monthFilter ? monthFilter.value : null;
        newMonth && setCurrentMonth(newMonth);
        newDate && setCurrentMonth(dayjs_min_default()(newDate).format("YYYYMM"));
        newDate && setCurrentDate(newDate);
    }, [
        filters
    ]);
    /** 달력 동기화 */ (0,react.useEffect)(function() {
        var ref;
        (ref = calendarRef.current) === null || ref === void 0 ? void 0 : ref.monthChange(currentMonth);
    }, [
        currentMonth
    ]);
    /** 달 변경 콜백 */ var onMonthChange = function(day) {
        var newMonth = day ? day.format("YYYYMM") : null;
        setCurrentMonth(newMonth);
    };
    /** 날짜 변경 콜백 */ var onDateChange = function(day) {
        var newDate = day ? day.format("YYYYMMDD") : null;
        setCurrentDate(newDate);
    };
    var eventByGoodsMonthFetch = (0,useEventByMonth/* default */.Z)(dspSid, goodsCd, currentMonth, {
        enabled: !!currentMonth && !optionFetch.isLoading,
        staleTime: 1000 * 60,
        select: function select(data) {
            var eventData = data.body;
            eventData.map(function(event) {
                var evProgDivi = event.evProgDivi, avlilBlockQty = event.avlilBlockQty, adtPrice = event.adtPrice, airTaxAdtPrice = event.airTaxAdtPrice, bafAdtPrice = event.bafAdtPrice;
                event.sumPrice = adtPrice + airTaxAdtPrice + bafAdtPrice;
                event.isEvReserve = "false"; // 예약가능 여부
                event.isEvConfirm = "false"; // 출발확정 여부
                if (evProgDivi !== "05" && (evProgDivi !== "00" && avlilBlockQty > 0 || evProgDivi === "00" || avlilBlockQty <= 0)) {
                    event.isEvReserve = "true";
                }
                if (evProgDivi === "07" || evProgDivi === "11") {
                    event.isEvConfirm = "true";
                }
                if (evProgDivi === "05") {
                    event.evReserveStatus = "end";
                } else if (evProgDivi === "00" || avlilBlockQty <= 0) {
                    event.evReserveStatus = "wait";
                } else {
                    event.evReserveStatus = "can";
                }
                return event.sumPrice;
            });
            return {
                minPrice: minPrice,
                list: eventData
            };
        }
    });
    var orgEventList = eventByGoodsMonthFetch.data;
    // 정렬 sort
    var ref10 = (0,react.useState)({
        text: "출발일순",
        prop: "outStartDt",
        asc: true
    }), sort = ref10[0], setSort = ref10[1];
    var handleSort = function(e) {
        var _dataset = e.target.dataset, text = _dataset.text, prop = _dataset.prop, asc = _dataset.asc;
        setSort({
            text: text,
            prop: prop,
            asc: asc === "true"
        });
    };
    // 필터 초기화
    (0,react.useEffect)(function() {
        var ref;
        if (!option) return;
        var currentFilter = ((ref = getFilter()) === null || ref === void 0 ? void 0 : ref.filter(function(v) {
            return v.key !== "sort";
        })) || [];
        var result = (0,_to_consumable_array/* default */.Z)(currentFilter.filter(function(v) {
            return v.key !== "airCd";
        }));
        // 날짜 데이터 세팅
        var outStartDateList = currentFilter.find(function(v) {
            return v.key === "outStartDateList";
        });
        if (outStartDateList) {
            if (outStartDateList.value.length === 6) {
                result.push({
                    key: "outStartMonth",
                    text: outStartDateList.text,
                    value: outStartDateList.value
                });
            } else if (outStartDateList.value.length === 8) {
                result.push({
                    key: "outStartDt",
                    text: outStartDateList.text,
                    value: outStartDateList.value
                });
            }
            result = result.filter(function(v) {
                return v.key !== "outStartDateList";
            });
        }
        var accommodationList = option.accommodationList, trafficList = option.trafficList;
        // 옵션
        if ((accommodationList === null || accommodationList === void 0 ? void 0 : accommodationList.length) > 0 && webDisplayCls === "B") {
            var _result;
            var accom = accommodationList.map(function(item) {
                return {
                    key: "accomSeq",
                    value: String(item.accomSeq),
                    text: item.accomNm
                };
            });
            (_result = result).push.apply(_result, (0,_to_consumable_array/* default */.Z)(accom));
        }
        // 교통편
        if (currentFilter.find(function(v) {
            return v.key === "airCd";
        })) {
            var _result1;
            var ref1;
            // 리스트에 선택된것만 세팅
            var airCdArray = (ref1 = currentFilter.filter(function(v) {
                return v.key === "airCd";
            })) === null || ref1 === void 0 ? void 0 : ref1.map(function(i) {
                return i.value;
            });
            var traffic = trafficList.filter(function(item) {
                return airCdArray.includes(item.trCompanySnm);
            }).map(function(item) {
                return {
                    key: "trCompanySnm",
                    value: item.trCompanySnm,
                    text: item.trCompanyNm
                };
            });
            (_result1 = result).push.apply(_result1, (0,_to_consumable_array/* default */.Z)(traffic));
        } else {
            var _result2;
            var traffic1 = trafficList.map(function(item) {
                return {
                    key: "trCompanySnm",
                    value: item.trCompanySnm,
                    text: item.trCompanyNm
                };
            });
            (_result2 = result).push.apply(_result2, (0,_to_consumable_array/* default */.Z)(traffic1));
        }
        setFilters(result);
    }, [
        option
    ]);
    /** 필터 된 리스트 */ var filteredList = (0,react.useMemo)(function() {
        if (!orgEventList) return;
        var minPrice = orgEventList.minPrice, list = orgEventList.list;
        var copyArray = list;
        filters === null || filters === void 0 ? void 0 : filters.forEach(function(item) {
            var filterKey = item.key;
            if (constant/* D_EXCLUDE_KEYS.indexOf */.we.indexOf(filterKey) > -1) return;
            copyArray = copyArray.reduce(function(acc, event) {
                var filterKeyList = filters.filter(function(v) {
                    return v.key === filterKey;
                });
                filterKeyList.some(function(filter) {
                    var key = filter.key, value = filter.value;
                    if (key === "minPrice") return Number(event.sumPrice) >= Number(value);
                    if (key === "maxPrice") return Number(event.sumPrice) <= Number(value);
                    return event[key] && event[key].indexOf(value) > -1;
                // eslint-disable-next-line no-param-reassign
                }) && (acc = acc.concat(event));
                return acc;
            }, []);
        });
        return {
            minPrice: minPrice,
            eventList: copyArray
        };
    }, [
        filters,
        orgEventList,
        currentMonth
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* ContentBottom */.pH, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* Schedule */.Pf, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* FixedScheduleWrap */.PT, {
                    children: currentMonth && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventListPopup_EventListCalendar, {
                        value: currentMonth,
                        data: filteredList,
                        maxDate: maxDate,
                        minDate: minDate,
                        onDateChange: onDateChange,
                        onMonthChange: onMonthChange,
                        ref: calendarRef
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* ScheduleWrap */.HA, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(EventSort, {
                            sort: sort,
                            handleSort: function(e) {
                                return handleSort(e);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* ScrollHeightBox */.fY, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventListFIlters, {
                                        filters: filters,
                                        setFilters: setFilters,
                                        option: option,
                                        goods: goods
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* PromotionWrap */.Kf, {
                                        children: [
                                            filteredList && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventListPopup_EventList, {
                                                data: filteredList.eventList,
                                                currentDate: currentDate,
                                                sort: sort,
                                                filters: filters,
                                                setFilters: setFilters,
                                                onClose: onClose
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* CalendarControl */.hS, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* CalendarButton */.au, {
                                                        type: "button",
                                                        month: "prev",
                                                        onClick: function() {
                                                            return calendarRef.current.prevMonth();
                                                        },
                                                        disabled: !((ref3 = calendarRef.current) === null || ref3 === void 0 ? void 0 : ref3.isPrevious),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                            children: "이전달"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: dayjs_min_default()((ref4 = calendarRef.current) === null || ref4 === void 0 ? void 0 : ref4.month).format("YYYY.MM")
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(departurepopup/* CalendarButton */.au, {
                                                        type: "button",
                                                        month: "next",
                                                        onClick: function() {
                                                            return calendarRef.current.nextMonth();
                                                        },
                                                        disabled: !((ref5 = calendarRef.current) === null || ref5 === void 0 ? void 0 : ref5.isNext),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                                                            children: "다음달"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var EventContents = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "EventListPop EventContents Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventContentsComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
var EventListPopComponent = function(props) {
    var ref;
    var goodsCd = props.goodsCd, availEvent = props.availEvent, overlayProps = (0,_object_without_properties/* default */.Z)(props, [
        "goodsCd",
        "availEvent"
    ]);
    var goodsFetch = (0,useGoodsDetail/* default */.ZP)(goodsCd);
    var goods = (ref = goodsFetch.data) === null || ref === void 0 ? void 0 : ref.body;
    if (goodsFetch.isFetching) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popup/* PopupContainer */.k, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, overlayProps), {
            size: "full",
            title: "출발일 보기",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(departurepopup/* ContentWrap */.Xs, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventInfo, (0,_object_spread/* default */.Z)({}, goods)),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventContents, {
                        goods: goods,
                        availEvent: availEvent,
                        onClose: overlayProps.close
                    })
                ]
            })
        }))
    });
};
// 출발일 보기
var EventListPopup = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "EventListPop Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventListPopComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var EventListPopup_EventListPopup = (EventListPopup);


/***/ }),

/***/ 59758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hu": function() { return /* binding */ SearchWrap; },
/* harmony export */   "IZ": function() { return /* binding */ OptionWrap; },
/* harmony export */   "Lf": function() { return /* binding */ OptionTextField; },
/* harmony export */   "YH": function() { return /* binding */ FilterHeader; },
/* harmony export */   "e_": function() { return /* binding */ GridList; },
/* harmony export */   "iu": function() { return /* binding */ OptionTitle; },
/* harmony export */   "mE": function() { return /* binding */ RatingHeader; },
/* harmony export */   "ol": function() { return /* binding */ Search; },
/* harmony export */   "tX": function() { return /* binding */ FloatingWrap; },
/* harmony export */   "wf": function() { return /* binding */ FloatingContent; }
/* harmony export */ });
/* unused harmony exports FilterTag, FilterTagWrap, OptionItem, OptionList, IconBox */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93391);
/* harmony import */ var _PUBLIC_P_images_btn_btn_spr_png__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14358);
/* harmony import */ var _PUBLIC_P_images_btn_btn_spr_png__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_PUBLIC_P_images_btn_btn_spr_png__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _FRAMEWORK_ui_desktop_icon_SearchIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75412);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	width: 100%;\n	min-height: 60px;\n	padding: 10px 0;\n	border-bottom: 1px solid var(--line-color);\n	background-color: #fff;\n	box-sizing: border-box;\n	align-items: center;\n	justify-content: space-between;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	position: relative;\n	display: flex;\n	margin-right: 10px;\n	background-color: transparent;\n	color: var(--default-color);\n	align-items: center;\n	line-height: 1;\n\n	i {\n		display: block;\n		position: relative;\n		width: 12px;\n		height: 12px;\n		margin-left: 5px;\n		font-size: 0;\n\n		&::before,\n		&::after {\n			position: absolute;\n			top: 50%;\n			left: 0;\n			right: 0;\n			height: 1px;\n			background: #7c7c7c;\n			transform: translateY(-50%);\n			content: "";\n		}\n\n		&::before {\n			transform: rotate(45deg);\n		}\n\n		&::after {\n			transform: rotate(-45deg);\n		}\n	}\n'
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	position: relative;\n	display: flex;\n	padding-left: 10px;\n	margin-left: 10px;\n	align-items: center;\n	flex-wrap: wrap;\n	gap: 5px;\n\n	&::before {\n		position: absolute;\n		left: 0;\n		top: 50%;\n		display: block;\n		width: 1px;\n		height: 13px;\n		background-color: var(--line-color);\n		transform: translateY(-50%);\n		content: "";\n	}\n\n	li {\n		display: flex;\n	}\n'
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: relative;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: sticky;\n	width: 240px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	height: 100%;\n	border-bottom: 1px solid var(--line-color);\n	cursor: pointer;\n\n	&:last-child {\n		border-bottom: none;\n	}\n\n	input[type="checkbox"] {\n		position: absolute;\n		width: 1px;\n		height: 1px;\n		padding: 0;\n		margin: -1px;\n		overflow: hidden;\n		clip: rect(0, 0, 0, 0);\n		border: 0;\n	}\n\n	label {\n		display: block;\n		height: 38px;\n		color: var(--default-color);\n		line-height: 38px;\n		text-overflow: ellipsis;\n		white-space: nowrap;\n		overflow: hidden;\n	}\n\n	input[type="checkbox"]:checked + label {\n		color: var(--emp-color);\n		background-color: var(--yellow-color);\n	}\n\n	span {\n		display: flex;\n		height: 100%;\n		align-items: center;\n		justify-content: center;\n		color: var(--bl-color);\n		cursor: auto;\n	}\n\n	',
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	max-height: ",
        ";\n	margin-bottom: 20px;\n	border: 1px solid var(--line-color);\n	flex-direction: ",
        ";\n	overflow-y: auto;\n\n	label {\n		padding-left: 10px;\n	}\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: grid;\n	margin: 0 1px;\n	grid-template-columns: ",
        ";\n	grid-gap: 1px;\n\n	li {\n		border: none;\n		outline: 1px solid var(--line-color);\n		text-align: center;\n	}\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	margin-bottom: 20px;\n	gap: 5px;\n	align-items: center;\n\n	input {\n		width: 100%;\n		text-align: right;\n	}\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	position: relative;\n	padding: 20px 0;\n	border-top: 1px solid var(--line-color);\n	font-size: var(--default-size);\n	color: var(--emp-color);\n	line-height: 1;\n	cursor: pointer;\n\n	&::before {\n		position: absolute;\n		right: 0;\n		top: 50%;\n		width: 10px;\n		height: 2px;\n		background-color: var(--emp-color);\n		transform: translateY(-50%);\n		content: "";\n	}\n\n	&::after {\n		position: absolute;\n		right: 4px;\n		top: 50%;\n		width: 2px;\n		height: 10px;\n		background-color: var(--emp-color);\n		transform: translateY(-50%);\n		content: "";\n	}\n\n	',
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	height: 0;\n	display: none;\n\n	",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	width: 100%;\n	height: 80px;\n	background-color: #fff;\n	align-items: center;\n	justify-content: space-between;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	background-color: #fff;\n	border: 1px solid var(--line-color);\n	align-items: center;\n\n	input {\n		width: 204px;\n		height: 38px;\n		padding: 0 0 0 9px;\n		border: none;\n\n		&::palceholder {\n			color: var(--gray-color);\n		}\n	}\n\n	button {\n		width: 16px;\n		height: 15px;\n		margin: 0 9px;\n		background: url(",
        ") 0px 0px / 93px 40px;\n	}\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	padding: 20px 0;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	display: flex;\n	height: 40px;\n	padding: 0 10px;\n	align-items: center;\n	border: 1px solid var(--line-color);\n	box-sizing: border-box;\n	background-color: #fff;\n\n	span {\n		margin-left: 8px;\n		font-family: "pr-font-medium";\n		color: var(--blue-color);\n	}\n'
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}




var FilterHeader = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-42d4884c-0"
})(_templateObject());
var FilterTag = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-42d4884c-1"
})(_templateObject1());
var FilterTagWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-42d4884c-2"
})(_templateObject2());
var FloatingContent = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-42d4884c-3"
})(_templateObject3());
var FloatingWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-42d4884c-4"
})(_templateObject4());
var OptionItem = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-42d4884c-5"
})(_templateObject5(), function(props) {
    return props.width && "\n        border-bottom: none;\n        border-right: 1px solid var(--line-color);\n        flex: 1 1 ".concat(props.width, ";\n        justify-content: center;\n\n        &:last-child {\n            border-right: none;\n        }\n\n        > label {\n            padding-left: 0;\n            justify-content: center;\n            text-align: center;\n        }\n    ");
});
var OptionList = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-42d4884c-6"
})(_templateObject6(), function(props) {
    return props.height || "195px";
}, function(props) {
    return props.direction || "column";
});
var GridList = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-42d4884c-7"
})(_templateObject7(), function(props) {
    return props.columns;
});
var OptionTextField = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-42d4884c-8"
})(_templateObject8());
var OptionTitle = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    componentId: "sc-42d4884c-9"
})(_templateObject9(), function(props) {
    return props.active && "\n        &::after {\n            display: none;\n        }\n    ";
});
var OptionWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-42d4884c-10"
})(_templateObject10(), function(props) {
    return props.show && "\n        height: auto;\n        display: block;\n    ";
});
var RatingHeader = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-42d4884c-11"
})(_templateObject11());
var Search = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-42d4884c-12"
})(_templateObject12(), (_PUBLIC_P_images_btn_btn_spr_png__WEBPACK_IMPORTED_MODULE_2___default()));
var SearchWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-42d4884c-13"
})(_templateObject13());
var IconBoxWrap = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-42d4884c-14"
})(_templateObject14());
var IconBox = function(_param) {
    var props = _extends({}, _param);
    /*#__PURE__*/ return _jsxs(IconBoxWrap, {
        onClick: props === null || props === void 0 ? void 0 : props.onClick,
        children: [
            /*#__PURE__*/ _jsx(SearchIcon, _object_spread({}, props)),
            /*#__PURE__*/ _jsx("div", {
                dangerouslySetInnerHTML: {
                    __html: props.innerHtml
                }
            })
        ]
    });
};



/***/ })

}]);